import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';

import { loadContainers } from '@eika-infrastruktur/render';
import { SkeletonThemeProvider } from '@eika/skeleton';

import { Config, defaultConfig } from './defaultConfig';
import ConsumerLoanConfirmationScreen from './widgets/ConsumerLoanConfirmationScreen/ConsumerLoanConfirmationScreen';
import LoanAccountActions from './widgets/LoanAccountActions/LoanAccountActions';
import LoanDetails from './widgets/LoanDetails/LoanDetails';
import LoanOverview from './widgets/LoanOverview/LoanOverview';
import LoanOwners from './widgets/LoanOwners/LoanOwners';
import Loans from './widgets/Loans/Loans';
import RefinancingConfirmationScreen from './widgets/RefinancingConfirmationScreen/RefinancingConfirmationScreen';

const globalCssNamespace = 'kkw';
export const REPO_NAMESPACE = 'kredittbank.kredittbanken';

const staleTime = 60 * 60 * 5; // 5 min
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime,
            retry: 1,
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: false,
            retryOnMount: false,
        },
    },
});

const renderApp = (MyApp: React.ComponentType, namespace: string, appDefaultConfig: Config = defaultConfig): void => {
    loadContainers(
        `${REPO_NAMESPACE}.${namespace}`,
        () => (
            <React.StrictMode>
                <QueryClientProvider client={queryClient}>
                    <SkeletonThemeProvider>
                        <div className={globalCssNamespace}>
                            <MyApp />
                        </div>
                    </SkeletonThemeProvider>
                </QueryClientProvider>
            </React.StrictMode>
        ),
        appDefaultConfig,
    );
};

renderApp(Loans, 'loans');
renderApp(RefinancingConfirmationScreen, 'refinancing-confirmation-screen');
renderApp(ConsumerLoanConfirmationScreen, 'consumer-loan-confirmation-screen');
renderApp(LoanDetails, 'loan-details');
renderApp(LoanOwners, 'loan-owners');
renderApp(LoanOverview, 'loan-overview');
renderApp(LoanAccountActions, 'loan-actions');
